module.exports = "/_next/static/images/03c8ce75f47059af729fd45348b3105c-mockup-conta-fgts@0.75x.jpg";